import { Suspense } from "react";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { UserTypeChart } from "./user-type-chart";
import { UserStatsChart } from "./user-stats-chart";
import { ReactNode } from "react";
import { UserCounts } from "@/features-root-user/service/organization";

interface ChartsSectionProps {
  userTypeChartData: Array<{
    name: string;
    size: number;
    color: string;
    users: any[];
  }>;
  statsData: Array<{
    name: string;
    value: number;
    icon: ReactNode;
  }>;
  userCounts?: UserCounts;
}

function ChartsSectionContent({
  userTypeChartData,
  statsData,
  userCounts,
}: ChartsSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <UserTypeChart
        userTypeChartData={userTypeChartData}
        userCounts={userCounts}
      />
      <UserStatsChart statsData={statsData} />
    </div>
  );
}

export function ChartsSection(props: ChartsSectionProps) {
  return (
    <EcosuiteErrorBoundary>
      <Suspense
        fallback={<LoadingScreen text="Loading charts..." className="h-72" />}
      >
        <ChartsSectionContent {...props} />
      </Suspense>
    </EcosuiteErrorBoundary>
  );
}
